import { z } from 'zod';
import { OMSRequirementsInputsSettings, OMSResourceRulesSettings } from '@/api/apis/resources/schedule';
import { OMSSchedulerSettingsInputsFormType, OMSSchedulerSettingsRulesFormType } from './types';
import { OrganType } from '@/api/apis/case';

export const getDefaultOMSSchedulerInputsValues = (
  data?: OMSRequirementsInputsSettings,
): OMSSchedulerSettingsInputsFormType => {
  const minForFirstSlotPerOrgan = data?.minForFirstSlotPerOrgan[OrganType.Heart].flex ?? 0;
  const minForSecondSlotPerOrgan = data?.minForSecondSlotPerOrgan[OrganType.Heart].flex ?? 0;
  return {
    minForFirstSlotPerOrgan,
    minForSecondSlotPerOrgan,
  };
};

const getSlotOrganValues = (flexValue: number) => {
  return Object.values(OrganType).reduce(
    (acc, organ) => {
      return { ...acc, [organ]: { strict: 0, flex: flexValue } };
    },
    {} as OMSRequirementsInputsSettings['minForFirstSlotPerOrgan'],
  );
};

export const getOMSSchedulerInputsSettingsFromForm = (
  data: OMSSchedulerSettingsInputsFormType,
): OMSRequirementsInputsSettings => {
  return {
    minForFirstSlotPerOrgan: getSlotOrganValues(data.minForFirstSlotPerOrgan),
    minForSecondSlotPerOrgan: getSlotOrganValues(data.minForSecondSlotPerOrgan),
  };
};

export const getDefaultOMSSchedulerRulesValues = (
  data: OMSResourceRulesSettings,
): OMSSchedulerSettingsRulesFormType => {
  return data;
};

export const getOMSSchedulerRulesSettingsFromForm = (
  data: OMSSchedulerSettingsRulesFormType,
): OMSResourceRulesSettings => {
  return {
    ...data,
    maxOnCallShiftsSlotsPerPeriod: data.minOnCallShiftsSlotsPerPeriod,
    maxAdminDaySlotsPerPeriod: data.minAdminDaySlotsPerPeriod,
  };
};

const numberSchema = z.number({ message: 'Required' }).min(0);

export const omsSchedulerSettingsInputsFormSchema = z.object({
  minForFirstSlotPerOrgan: numberSchema,
  minForSecondSlotPerOrgan: numberSchema,
});

export const omsSchedulerSettingsRulesFormSchema = z.object({
  maxOnCallShiftsSlotsPerPeriod: numberSchema,
  minOnCallShiftsSlotsPerPeriod: numberSchema,
  maxAdminDaySlotsPerPeriod: numberSchema,
  minAdminDaySlotsPerPeriod: numberSchema,
});
